import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { resolveStatic } from 'utils/assets';
import { gettext } from 'utils/text';
import { FPImageShape } from 'utils/shapes';
import reverseUrl from 'utils/urls';

const SliderArrow = (props) => {
    const { className, onClick } = props;
    return (
        <a className={className} onClick={onClick} /> // eslint-disable-line jsx-a11y/anchor-has-content
    );
};

SliderArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
};

SliderArrow.defaultProps = {
    className: '',
    onClick: () => null,
};

const BgSlider = ({ images, periodUntil, theme }) => {
    const buttons = [];

    if (periodUntil) {
        buttons.push(
            <div key="fundingbtn" className="btn-caption-group mr-3">
                <a href={reverseUrl('trafo_fundingapplication_start')} className="btn btn-primary">
                    {gettext('Apply for 10 000,-')}
                </a>
                <span className={`btn-caption btn-caption--${theme}`}>
                    {periodUntil}
                    {gettext('to apply')}
                </span>
            </div>,
        );
    }
    buttons.push(
        <a key="mentorbtn" href={reverseUrl('trafo_mentorapplication_start')} className="btn btn-outline-light">
            {gettext('Apply for mentorship')}
        </a>,
    );
    const children = images.map((img) => {
        return (
            <div key={`img-${img.order}`} className="fp-slide">
                <div className="fp-slide__content" style={{ backgroundImage: `url(${img.url})` }}>
                    <div className="container">
                        <div className="hero__center">
                            <h1 className="hero__title">{img.flavour}</h1>
                            <div className="hero__center__buttons">{buttons}</div>
                        </div>
                        <div className="hero__bottom">
                            <div className="hero__left">
                                <a href="https://www.kulturradet.no/" target="_blank" rel="noopener noreferrer">
                                    <img src={resolveStatic('images/kulturradet.svg')} alt="kulturradet logo" />
                                </a>
                            </div>
                            <div className="hero__middle">
                                <div id="scroll-down">
                                    <a href="#creativity">
                                        <i className="icon icon--arrow-circle" />
                                    </a>
                                </div>
                            </div>
                            <div className="hero__right">
                                <div className="hero__caption">
                                    <div className="hero__caption__title">{img.title}</div>
                                    <div className="hero__caption__author">{img.author}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 500,
        autoplaySpeed: 4000,
        fade: true,
        arrows: false,
    };

    return (
        <Slider
            {...settings}
            /* Arrows currently disabled by arrows: false in settings. Keeping the arrows here in case we need to
             * re-enable them later */
            nextArrow={<SliderArrow />}
            prevArrow={<SliderArrow />}
        >
            {children}
        </Slider>
    );
};

BgSlider.propTypes = {
    images: PropTypes.arrayOf(FPImageShape).isRequired,
    theme: PropTypes.string,
    periodUntil: PropTypes.string,
};

BgSlider.defaultProps = {
    theme: 'white',
    periodUntil: '',
};

export default BgSlider;



// WEBPACK FOOTER //
// ./src/components/frontpage/slider.js